import * as React from 'react';

const DasLocateNormalSvgColor = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 26H5V24H27V26ZM25 23H7V16H25V23ZM10.5 21C10.2239 21 10 21.2239 10 21.5C10 21.7761 10.2239 22 10.5 22C10.7761 22 11 21.7761 11 21.5C11 21.2239 10.7761 21 10.5 21ZM13.5 21C13.2239 21 13 21.2239 13 21.5C13 21.7761 13.2239 22 13.5 22C13.7761 22 14 21.7761 14 21.5C14 21.2239 13.7761 21 13.5 21ZM16.5 21C16.2239 21 16 21.2239 16 21.5C16 21.7761 16.2239 22 16.5 22H18.5C18.7761 22 19 21.7761 19 21.5C19 21.2239 18.7761 21 18.5 21H16.5ZM21.5 21C21.2239 21 21 21.2239 21 21.5C21 21.7761 21.2239 22 21.5 22C21.7761 22 22 21.7761 22 21.5C22 21.2239 21.7761 21 21.5 21ZM12 12V15H10V12L10.5 6H11.5L12 12ZM22 12V15H20V12L20.5 6H21.5L22 12Z"
      fill="#E5E5E5"
    />
    <circle cx="6" cy="26" r="6" fill="white" />
    <path
      d="M6 22C7.76723 22 9.20005 23.4651 9.2002 25.2725C9.2002 28.1799 6.00375 29.9979 6 30C5.99071 29.9947 2.7998 28.1773 2.7998 25.2725C2.79995 23.4651 4.23278 22 6 22ZM6 23.5996C5.11634 23.5996 4.40039 24.3165 4.40039 25.2002C4.40049 26.0838 5.11641 26.7998 6 26.7998C6.8836 26.7998 7.59951 26.0838 7.59961 25.2002C7.59961 24.3165 6.88366 23.5996 6 23.5996Z"
      fill="#FF6B00"
    />
  </svg>
);

export default DasLocateNormalSvgColor;
